'use strict'
const fetch = require('isomorphic-fetch')

import {
  BASE_URL,
  VUE_APP_URL,
  GOOGLE_SIGN_UP_KEY,
  CM_BASE_URL,
  SALESGEAR
} from './constants/constants'

import { getQueryParamFromUrl } from './commonUtil'
// const sharedFunctions = require('./functions')

export const ONBOARDING_URL = VUE_APP_URL + '/start'

export function put(path, data) {
  const url = constructUrl(path)
  return putFromCustomUrl(url, data)
}
export function post(path, data, requestId) {
  const url = constructUrl(path)
  return postFromCustomUrl(url, data, requestId)
}

export function get(path, queryObject, apiType) {
  let url = constructUrl(path, apiType)
  if (queryObject) {
    url = constructUrl(path + queryObject)
  }
  return getFromCustomUrl(url)
}

export function deleteData(path) {
  let url = constructUrl(path)
  return deleteFromCustomUrl(url)
}

export function getFromCustomUrl(url) {
  const data = { url: url, method: 'GET' }
  return rest(data)
}

export function postFromCustomUrl(url, data, requestId) {
  let dataMap = {}
  if (data) dataMap = data

  const params = {
    url: url,
    method: 'POST',
    body: JSON.stringify(dataMap),
    headers: new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json'
    })
  }
  return rest(params, requestId)
}

export function putFromCustomUrl(url, data) {
  let dataMap = {}
  if (data) dataMap = data
  const params = {
    url: url,
    method: 'PUT',
    body: JSON.stringify(dataMap)
  }
  return rest(params)
}

export function deleteFromCustomUrl(url) {
  const data = { url: url, method: 'DELETE' }
  return rest(data)
}

function rest(arg, requestId) {
  let params = {
    method: arg.method,
    body: arg.body,
    mode: 'cors',
    headers: new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }),
    credentials: 'include'
  }
  if (requestId) {
    params.headers.append('requestId', requestId)
  }
  return fetch(arg.url, params).then(res => {
    if (res && res.status == 401) {
      // eslint-disable-next-line no-constant-condition
      // const adaProsExtV = localStorage.getItem('adaProsExtV')
      // if (adaProsExtV !== null && adaProsExtV == '1.0.72') {
      window.prospector.$children[0].$refs.auth.setShowSignUp()
      // } else {
      // openSignupInIframe()
      // }
      return null
    } else {
      return res
    }
  })
}

export function constructUrl(url, apiType) {
  if (apiType && apiType === SALESGEAR) {
    return `${CM_BASE_URL}/${url}`
  }
  return `${BASE_URL}/${url}`
}

// function openSignupInIframe() {
//   const url = constructUrl(
//     `login.htm?slc=lip&login=false&targetUrl=${VUE_APP_URL}/success`
//   )
//   const _frame_id = 'id_frame'
//   let iframe = document.createElement('iframe')
//   iframe.src = url
//   iframe.id = _frame_id
//   iframe.className = 'iframe-popup'
//   let div = document.createElement('div')
//   div.className = 'overlay'
//   div.innerHTML = `<i class="fa fa-circle-o-notch fa-spin login-spinner" style="font-size:24px"></i>`
//   // div.addEventListener('click', function () {
//   //   removeSignupPopup()
//   // })
//   const isAlreadyLoaded = document.querySelector(`#${_frame_id}`)
//   if (!isAlreadyLoaded) {
//     document.body.appendChild(iframe)
//     document.body.appendChild(div)
//     sharedFunctions.default.track('AP - Signup shown')
//   }
//   const intervalId = setInterval(function() {
//     try {
//       if (iframe.contentWindow.location.href == `${VUE_APP_URL}/success`) {
//         clearInterval(intervalId)
//         removeSignupPopup()
//         window.location.href = ONBOARDING_URL
//       }
//     } catch (e) {
//       console.log(e)
//     }
//   }, 2000)
// }

window.addEventListener('message', function(ev) {
  if (ev && ev.data) {
    if (ev.data.type == 'adaProsExtV') {
      const adaProsExtV = localStorage.getItem('adaProsExtV')
      if (adaProsExtV == null) {
        localStorage.setItem('adaProsExtV', ev.data.data)
        if (document.getElementById('id_frame') !== null) {
          document.body.removeChild(
            document.getElementsByClassName('overlay')[0]
          )
          document.body.removeChild(document.getElementById('id_frame'))
        }
      }
    }
  }
})
// function removeSignupPopup(div, iframe) {
//   if (div) document.body.removeChild(div)
//   if (iframe) document.body.removeChild(iframe)
// }

export const openGoogleAuth = authCallback => {
  const authUrl =
    'https://accounts.google.com/o/oauth2/auth?client_id=' +
    GOOGLE_SIGN_UP_KEY.client_id +
    '&scope=' +
    GOOGLE_SIGN_UP_KEY.scope +
    '&immediate=false&access_type=offline&response_type=code&redirect_uri=' +
    BASE_URL
  const w = 600
  const h = 800
  const left = window.screen.width / 2 - w / 2
  const top = window.screen.height / 2 - h / 2
  let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=${w},height=${h},left=${left},top=${top}`
  const openedWindow = window.open(authUrl, 'Adapt', params)
  window.addEventListener('message', function(ev) {
    if (ev && ev.data) {
      if (ev.data.type == 'google_auth_prospector') {
        const auth_url = new URL(ev.data.data)
        const authJson = getQueryParamFromUrl(auth_url.search)

        if (authJson.code !== undefined) {
          authCallback({ code: authJson.code })
        }
        openedWindow.close()
      }
    }
  })
}
